import React, { Component } from "react";
import colors from "@streeteasy/design-system/deprecated/colors";
import XButton from "@streeteasy/design-system/deprecated/XButton";
import { bool, func, node, string } from "prop-types";
import { uncontrollable } from "uncontrollable";

import { CloseButtonWrapper, DismissableContent } from "./styled";

/**
 * Component which renders any child nodes as well as a close button. It can be
 * used both as a controlled or uncontrolled component. If the parent supplies
 * values for the `isOpen` and `onToggle` props, the instance will call
 * `onToggle` when the user clicks the close button, and the parent is
 * responsible for updating the `isOpen` prop accordingly. If the parent
 * doesn't supply those two props, the instance will use its own state to hide
 * itself when the close button is clicked and cannot be reopened.
 *
 */
export class Dismissable extends Component {
  static propTypes = {
    /**
     * Any nodes that should be rendered inside the modal's content box.
     */
    children: node,
    /**
     * Optional custom color for the close button, defaults to goatGrey from
     * the StreetEasy color palette.
     */
    closeButtonColor: string,
    /**
     * Whether the modal should be visible or not.
     */
    isOpen: bool,
    /**
     * Callback function for when the close button is clicked. If provided,
     * this instance's parent is responsible for updating `isOpen` accordingly.
     *
     * @param {bool} isOpen
     */
    onToggle: func
  };

  static defaultProps = {
    children: null,
    closeButtonColor: colors.goatGrey,
    isOpen: true,
    onToggle: () => {}
  };

  handleClickClose = () => {
    const { onToggle } = this.props;
    onToggle(false);
  };

  render() {
    const { children, closeButtonColor, isOpen } = this.props;
    return (
      isOpen && (
        <DismissableContent {...this.props}>
          <CloseButtonWrapper>
            <XButton color={closeButtonColor} onClick={this.handleClickClose} />
          </CloseButtonWrapper>
          {children}
        </DismissableContent>
      )
    );
  }
}

export default uncontrollable(Dismissable, { isOpen: "onToggle" });
